import React from 'react'
import AboutCoachKshitij from './AboutUs/AboutCoashKshitij'
import CoachTestSection from './AboutUs/CoachTestSection'
import Testenomial from './LandingPage/Testenomial'

const About = () => {
  return (
    <div className='navFixMargin'>
      <AboutCoachKshitij />
      <CoachTestSection />
      <Testenomial />
      
    </div>
  )
}

export default About